/* ============================================================
   MOTION 33 — THEME JAVASCRIPT
   ============================================================ */

document.addEventListener('DOMContentLoaded', function() {

  // --- CART DRAWER ---
  const cartDrawer = document.getElementById('cart-drawer');
  const cartOverlay = document.getElementById('cart-overlay');
  const cartBtns = document.querySelectorAll('[data-open-cart]');
  const cartClose = document.getElementById('cart-close');

  function openCart() {
    if (cartDrawer) {
      cartDrawer.classList.add('open');
      cartOverlay && cartOverlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeCart() {
    if (cartDrawer) {
      cartDrawer.classList.remove('open');
      cartOverlay && cartOverlay.classList.remove('active');
      document.body.style.overflow = '';
    }
  }

  cartBtns.forEach(btn => btn.addEventListener('click', openCart));
  cartClose && cartClose.addEventListener('click', closeCart);
  cartOverlay && cartOverlay.addEventListener('click', closeCart);

  // --- MOBILE MENU ---
  const menuToggle = document.getElementById('mobile-menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');

  if (menuToggle && mobileMenu) {
    menuToggle.addEventListener('click', function() {
      const isOpen = mobileMenu.classList.toggle('open');
      menuToggle.setAttribute('aria-expanded', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });
  }

  // --- ACCORDION ---
  document.querySelectorAll('.accordion__trigger').forEach(trigger => {
    trigger.addEventListener('click', function() {
      const item = this.closest('.accordion__item');
      const isOpen = item.classList.contains('open');

      // Close all
      document.querySelectorAll('.accordion__item.open').forEach(el => {
        el.classList.remove('open');
      });

      // Open clicked if was closed
      if (!isOpen) item.classList.add('open');
    });
  });

  // --- PRODUCT GALLERY ---
  const thumbs = document.querySelectorAll('.product-gallery__thumb');
  const mainImage = document.querySelector('.product-gallery__main img');

  thumbs.forEach(thumb => {
    thumb.addEventListener('click', function() {
      thumbs.forEach(t => t.classList.remove('active'));
      this.classList.add('active');
      if (mainImage) {
        mainImage.src = this.querySelector('img').src;
        mainImage.srcset = this.querySelector('img').srcset || '';
      }
    });
  });

  // --- PRODUCT CAROUSELS ---
  document.querySelectorAll('.product-carousel-wrapper').forEach(wrapper => {
    const carousel = wrapper.querySelector('.product-carousel');
    const prevBtn = wrapper.querySelector('.carousel-prev');
    const nextBtn = wrapper.querySelector('.carousel-next');

    if (!carousel) return;

    function getScrollAmount() {
      const card = carousel.querySelector('.product-card');
      return card ? card.offsetWidth + 24 : 300;
    }

    prevBtn && prevBtn.addEventListener('click', () => {
      carousel.scrollBy({ left: -getScrollAmount() * 2, behavior: 'smooth' });
    });

    nextBtn && nextBtn.addEventListener('click', () => {
      carousel.scrollBy({ left: getScrollAmount() * 2, behavior: 'smooth' });
    });
  });

  // --- VARIANT SELECTION ---
  document.querySelectorAll('.size-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      if (this.classList.contains('unavailable')) return;
      const group = this.closest('.size-selector');
      group.querySelectorAll('.size-btn').forEach(b => b.classList.remove('active'));
      this.classList.add('active');
    });
  });

  document.querySelectorAll('.color-option').forEach(opt => {
    opt.addEventListener('click', function() {
      const group = this.closest('.color-selector');
      group.querySelectorAll('.color-option').forEach(o => o.classList.remove('active'));
      this.classList.add('active');
    });
  });

  // --- ADD TO CART ---
  document.querySelectorAll('.atc-btn').forEach(btn => {
    btn.addEventListener('click', async function(e) {
      e.preventDefault();
      const variantId = this.dataset.variantId;
      if (!variantId) return;

      const originalText = this.textContent;
      this.textContent = 'Adding...';
      this.disabled = true;

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });

        if (response.ok) {
          this.textContent = 'Added!';
          await updateCartCount();
          openCart();
          setTimeout(() => {
            this.textContent = originalText;
            this.disabled = false;
          }, 2000);
        }
      } catch (err) {
        this.textContent = originalText;
        this.disabled = false;
      }
    });
  });

  async function updateCartCount() {
    try {
      const res = await fetch('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
    } catch (e) {}
  }

  updateCartCount();

  // --- QUICK ADD ---
  document.querySelectorAll('.product-card__quick-add').forEach(btn => {
    btn.addEventListener('click', async function(e) {
      e.preventDefault();
      e.stopPropagation();
      const variantId = this.dataset.variantId;
      if (!variantId) return;

      const original = this.textContent;
      this.textContent = 'Added ✓';

      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        });
        await updateCartCount();
        openCart();
      } catch (e) {}

      setTimeout(() => { this.textContent = original; }, 2000);
    });
  });

  // --- NEWSLETTER FORM ---
  const newsletterForm = document.querySelector('.newsletter-form');
  if (newsletterForm) {
    newsletterForm.addEventListener('submit', function(e) {
      e.preventDefault();
      const email = this.querySelector('input[type="email"]').value;
      if (email) {
        this.querySelector('input').value = '';
        const btn = this.querySelector('.newsletter-form__btn');
        const orig = btn.textContent;
        btn.textContent = '✓ Subscribed';
        setTimeout(() => btn.textContent = orig, 3000);
      }
    });
  }

  // --- CART QTY BUTTONS ---
  document.addEventListener('click', async function(e) {
    if (e.target.matches('.qty-btn')) {
      const action = e.target.dataset.action;
      const key = e.target.dataset.key;
      const qtyEl = e.target.closest('.cart-item__qty').querySelector('.qty-value');
      let qty = parseInt(qtyEl.textContent);

      if (action === 'increase') qty++;
      if (action === 'decrease') qty = Math.max(0, qty - 1);

      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: qty })
        });
        location.reload();
      } catch (e) {}
    }
  });

  // --- SEARCH ---
  const searchToggle = document.getElementById('search-toggle');
  const searchDrawer = document.getElementById('search-drawer');
  const searchClose = document.getElementById('search-close');

  searchToggle && searchToggle.addEventListener('click', () => {
    searchDrawer && searchDrawer.classList.toggle('open');
    searchDrawer && searchDrawer.querySelector('input')?.focus();
  });

  searchClose && searchClose.addEventListener('click', () => {
    searchDrawer && searchDrawer.classList.remove('open');
  });

  // --- FILTER BUTTONS ---
  document.querySelectorAll('.filter-btn').forEach(btn => {
    btn.addEventListener('click', function() {
      // URL-based filter
      const filterKey = this.dataset.filterKey;
      const filterVal = this.dataset.filterValue;
      if (filterKey && filterVal) {
        const url = new URL(window.location);
        url.searchParams.set(filterKey, filterVal);
        window.location = url.toString();
      }
    });
  });

  // --- STICKY HEADER SHRINK ---
  const header = document.querySelector('.site-header');
  let lastScroll = 0;

  window.addEventListener('scroll', () => {
    const current = window.pageYOffset;
    if (header) {
      if (current > 80) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
      if (current > lastScroll && current > 200) {
        header.classList.add('hidden');
      } else {
        header.classList.remove('hidden');
      }
    }
    lastScroll = current;
  }, { passive: true });

});
